export const STATISTICS_SELECT_DATASET_EVENT = 'statistics:selectDataset';
export const STATISTICS_SUMMARY_UPDATED_EVENT = 'statistics:summaryUpdated';

export function emitStatisticsDatasetSelection(datasetKey) {
  if (typeof window === 'undefined' || !datasetKey) return;

  window.dispatchEvent(
    new CustomEvent(STATISTICS_SELECT_DATASET_EVENT, {
      detail: { datasetKey }
    })
  );
}

export function emitStatisticsSummaryUpdated(detail) {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent(STATISTICS_SUMMARY_UPDATED_EVENT, {
      detail: detail ?? {}
    })
  );
}
